// extracted by mini-css-extract-plugin
export default {"social_bar":"SocialBar_social_bar__A4W7e"};